var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.show!=false)?_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }